module.exports = __webpack_public_path__ + "img/partner-nnjtjt.163d800b.png";